import { AttrField, BooleanField, OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.UI_SETTINGS)
export default class UiSettings extends BaseModel {
  @BooleanField()
  public ticketsPropsIsGettingStartedPageHidden: boolean

  @AttrField(null)
  public openAIConsent: boolean | null

  @BooleanField()
  public composeSwitchChannelsTooltipHidden: boolean

  @BooleanField()
  public emailCampaignIsPromotionalModalChecked: boolean

  @BooleanField()
  public emailCampaignWarmupGuidelinesChecked: boolean

  @BooleanField()
  public contactsImportDataCleanupStepHidden: boolean

  @BooleanField()
  public automationAiBuilderFeatureTooltipHidden: boolean
}
